import type { CustomValues } from '@atlassian/browser-metrics/types';

import { networkTracker } from '@confluence/network';

export const frontendNetworkPlugin = ({}): CustomValues => {
	// Only track frontend calls, skip during SSR
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR || typeof window === 'undefined') {
		return {
			frontendTotalOperations: 0,
		};
	}

	const stats = networkTracker.getStats();

	return {
		frontendTotalOperations: stats.totalOperations,
	};
};
